export default "__VITE_ASSET__53661456__"